<div #container class="image-container" (wheel)="onWheel($event)" (mousedown)="onMouseDown($event)"
  (mousemove)="onMouseMove($event)" (mouseup)="onMouseUp($event)" (mouseleave)="onMouseLeave($event)"
  [class.isInvisibil]="!loaded">

  <img #image [src]="url" alt="Interactive Image" [style.transform]="transform" (load)="onImageLoad()" draggable="false"
    (error)="handleError($event)" />

</div>